(() => {
  const readPDPStickyATC = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const forcedEnabled = urlParams.get('pdm-pdp-sticky-atc');
    const holdoutGroup = window._growthbook.getFeatureValue(
      'holdout-pdm-gilded-new-york',
      'OFF'
    );
    const enabled = holdoutGroup !== 'holdout-q3-2026';

    if (forcedEnabled || enabled) {
      document.body.dataset.pdmPdpStickyAtc = 'true';
      document.dispatchEvent(new CustomEvent('pdp-sticky-atc:updated'));
    }
  };

  const readStickyRibbon = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      'holdout-pdm-gilded-new-york',
      'OFF'
    );
    const enabled = holdoutGroup !== 'holdout-q3-2026';

    if (enabled) {
      document.body.setAttribute('data-pdm-sticky-ribbon', 'true');
    }
  };

  const readCategoryCarousel = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      'holdout-pdm-gilded-new-york',
      'OFF'
    );

    const categoryCarousel = window._growthbook.getFeatureValue(
      'pdm-gildedny-category-carousel',
      false
    );

    if (holdoutGroup !== 'holdout-q3-2026' && categoryCarousel) {
      document.body.setAttribute('data-pdm-category-carousel', true);
    }
  };

  const readQuickATCPLP = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      'holdout-pdm-gilded-new-york',
      'OFF'
    );
    if (holdoutGroup !== 'holdout-q3-2026') {
      document.body.setAttribute('data-plp-quick-atc', true);
    }
  };

  const readValueProps = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      'holdout-pdm-gilded-new-york',
      'OFF'
    );
    if (holdoutGroup !== 'holdout-q3-2026') {
      document.body.setAttribute('data-value-props', true);
    }
  };

  const readMobilePlpSwiper = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      'holdout-pdm-gilded-new-york',
      'OFF'
    );
    if (holdoutGroup !== 'holdout-q3-2026') {
      document.body.setAttribute('data-swiper-plp', true);
    }
  };
  const readPDPValueProps = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      'holdout-pdm-gilded-new-york',
      'OFF'
    );
    const enabled = holdoutGroup !== 'holdout-q3-2026';

    if (enabled) {
      document.body.dataset.pdpValueProps = 'B';
    }
  };

  const readShopByShape = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      'holdout-pdm-gilded-new-york',
      'OFF'
    );
    const enabled = holdoutGroup !== 'holdout-q3-2026';

    if (enabled) {
      document.body.setAttribute('data-pdm-shop-by-shape', 'true');
    }
  };

  const readSizeGuide = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const forcedValue = Number(urlParams.get("pdm-pdp-size-guide")) || 0;
    const isPLPBadgeFlag = Number(
      window._growthbook.getFeatureValue("pdm-gildedny-pdp-size-guide", false),
    );
    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-gilded-new-york",
      "OFF",
    );

    const enabled = holdoutGroup !== "holdout-q3-2026";
    const variant = !enabled ? 0 : isPLPBadgeFlag || forcedValue;

    if (variant === 1) {
      document.body.dataset.testSizeGuide = "true";
    }
  };

  const readShopByCarat = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      'holdout-pdm-gilded-new-york',
      'OFF'
    );

    const shopByCarat = window._growthbook.getFeatureValue(
      'pdm-shop-by-carat-menu',
      false
    );

    if (holdoutGroup !== 'holdout-q3-2026' && shopByCarat) {
      document.body.setAttribute('data-pdm-shop-by-carat', 'true');
    }
  };

  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push(() => {
    const applyFeatureFlags = () => {
      readPDPStickyATC();
      readStickyRibbon();
      readCategoryCarousel();
      readMobilePlpSwiper();
      readSizeGuide();
      readShopByShape ();
      readShopByCarat();
      readPDPValueProps();
      readQuickATCPLP();
      readValueProps();
    };

    applyFeatureFlags();
    document.addEventListener('growthbookdata', applyFeatureFlags);
  });
})();
